import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import InputHOC from './HOC/Input'

import style from './Select.scss'

class Select extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    options: PropTypes.array,
    className: PropTypes.string,
    invalid: PropTypes.bool,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    onChange: PropTypes.func,
  }

  static defaultValue = {
    value: '',
    options: [],
  }

  render() {
    const { name, value, invalid, className, options, onChange, onBlur, onFocus } = this.props

    const componentClass = cx(style.select, {
      [style.error]: invalid,
      [className]: className,
    })

    return (
      <select
        name={name}
        value={value}
        className={componentClass}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
      >
        <option value="" disabled hidden default />
        {options.map((key) => (
          <option key={key} value={key}>
            {key}
          </option>
        ))}
      </select>
    )
  }
}

export default InputHOC(Select)



// WEBPACK FOOTER //
// ./src/components/Common/Select.js